import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryGrid() {
  return (
    <section className="bg-background-100/50 border-y border-background-200/50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            探索穿搭世界
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">
            六大分类，全方位打造属于你的绅士风格
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-lg border border-background-200/70 p-5 md:p-6 hover:border-primary-200/50 hover:bg-primary-50/30 transition-all duration-300"
            >
              <div className="w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-primary-100/70 text-primary-600 mb-3 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-1.5">
                {cat.name}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}